function splitTextOnLines(text, maxCharsInLine) {
  if (!text) return null;

  const keepOneLine = !maxCharsInLine || maxCharsInLine < 1 || text.length <= maxCharsInLine;

  if (keepOneLine) return [text];

  const pattern = `[^]{1,${Math.max(maxCharsInLine - 3, 1)}}`;

  const lines = text.replace(/\s+/g, ' ').match(new RegExp(pattern, 'g'));

  if (!lines) return [text];

  return lines.map(line => line.trim());
}

export default splitTextOnLines;



// WEBPACK FOOTER //
// ../ui-components/components/Tooltip/splitTextOnLines/index.js